import { endpointRequest } from '../EndpointService/EndpointFunctions';

const createAlertSettingsService = jokiInstance => {
    const serviceId = 'AlarmSettingService';
    const joki = jokiInstance;

    let alertConfig = null;
    let activeOrganization = null;
    let configResponse = null;

    const messageHandler = event => {
        switch (event.key) {
            case 'get_alert_config':
                if (alertConfig === null) {
                    fetchAlertConfig();
                }
                break;
            case 'create_alert_config':
                if (activeOrganization === null) {
                    return;
                }
                createAlertNotification(event.body.payload);
                break;
            case 'update_alert_config':
                if (activeOrganization === null) {
                    return;
                }
                updateAlertNotification(event.body.payload, event.body.configId);
                break;
            case 'delete_alert_config':
                if (activeOrganization === null || !event.body.configId) {
                    return;
                }
                deleteAlertNotification(event.body.configId);
                break;
            default:
                break;
        }
    };

    joki.on({
        from: 'React:AlertConfigCreatedOrUpdatedOrDeletedOrOrgChange',
        key: 'alertConfigRefetch',
        fn: event => {
            if (Object.keys(event.body.value).length > 0 && event.body.value.value !== '') {
                activeOrganization = event.body.value.value;
                fetchAlertConfig();
            }
        },
    });

    const fetchAlertConfig = async () => {
        try {
            const result = await endpointRequest(joki, 'get_alert_config', {
                filters: { id: `"${activeOrganization}"` },
            });

            if (result) {
                alertConfig = result;
                configResponse = null;
                triggerServiceUpdate();
            }
        } catch (error) {
            console.error(error);
        }
    };

    //create an alert config
    const createAlertNotification = async payload => {
        try {
            const response = await endpointRequest(joki, 'create_alert_config', {
                body: payload,
                urlParse: {
                    $organizationId$: activeOrganization,
                },
            });

            if (response && response.hasOwnProperty('configurationId') && !response.hasOwnProperty('message')) {
                configResponse = response;
            } else {
                configResponse = null;
                console.error(response);
            }
            triggerServiceUpdate();
        } catch (error) {
            console.error(error);
        }
    };

    //update an existing alert config
    const updateAlertNotification = async (payload, configId) => {
        try {
            const response = await endpointRequest(joki, 'update_alert_config', {
                body: payload,
                urlParse: {
                    $organizationId$: activeOrganization,
                    $configurationId$: configId,
                },
            });

            if (response && response.hasOwnProperty('configurationId') && !response.hasOwnProperty('message')) {
                configResponse = response;
            } else {
                configResponse = null;
                console.error(response);
            }

            triggerServiceUpdate();
        } catch (error) {
            console.error(error);
        }
    };

    //delete an alert
    const deleteAlertNotification = async configId => {
        try {
            const response = await endpointRequest(joki, 'delete_alert_config', {
                urlParse: {
                    $organizationId$: activeOrganization,
                    $configurationId$: configId,
                },
            });

            if (response && response.hasOwnProperty('configurationId') && !response.hasOwnProperty('message')) {
                configResponse = response;
            } else {
                configResponse = null;
                console.error(response);
            }
            triggerServiceUpdate();
        } catch (error) {
            console.error(error);
        }
    };

    const triggerServiceUpdate = () => {
        joki.serviceUpdate(serviceId, { alertConfig, configResponse }, { serviceUpdate: true });
    };

    joki.addService({
        id: serviceId,
        fn: messageHandler,
    });
};

export default createAlertSettingsService;
